import script from "./sf-radio-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-radio-group.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__